import { LoadingContent } from "../../components/common/Loading/loadingContent";

export const LoadingPage = () => {
  return <LoadingContent />;
};
